module.exports = __webpack_public_path__ + "static/media/alert.5ef43658.svg";